import { call, put, takeLatest } from "redux-saga/effects";
import { listWorkflowsApi } from "../../../api/apiLists/workflow";
import {
  fetchWorkflowListFailure,
  fetchWorkflowListRequest,
  fetchWorkflowListStart,
  fetchWorkflowListSuccess
} from "../../slices/workflow";
import { callWorkflowApi, requireWhatsAppModuleAccess } from "./workflowSagaHelper";

function* handleFetchWorkflowList(action) {
  if (!(yield call(requireWhatsAppModuleAccess))) return;

  try {
    yield put(fetchWorkflowListStart());

    const req = action.payload || { operation: "LIST_WORKFLOWS", payload: {} };
    const res = yield callWorkflowApi(listWorkflowsApi, req);

    if (res?.status) {
      yield put(fetchWorkflowListSuccess(res?.data?.workflows || []));
      return;
    }

    yield put(fetchWorkflowListFailure(res?.errMsg || "Failed to load workflows"));
  } catch (error) {
    yield put(fetchWorkflowListFailure(error.message || "Failed to load workflows"));
  }
}

export default function* workflowListSaga() {
  yield takeLatest(fetchWorkflowListRequest.type, handleFetchWorkflowList);
}
